import config from "../../../config";
import React from "react";
import { ApiHandlerPureComponent } from "./ApiHandlerPureComponent";
import { Region, RegionSubmission } from "../interfaces/Region";
import { handleResponseArray } from "./APIHandlerHelper";
import { RegionMapping, RegionMappingSubmission } from "../interfaces/RegionMapping";

interface Props {
  onAuthError?: () => void;
}

export default class CompanyAPIs extends React.PureComponent<Props> {
  private apiResponseHandler = new ApiHandlerPureComponent({
    onAuthError: this.props.onAuthError,
  });

  private static readonly BASE_URL: string = `${config.apiGateway.META_API}/api/companies/`;

  getCompaniesByCustomerId = (customerId: number): Promise<Region[]> => {
    const apiCompanies = `${CompanyAPIs.BASE_URL}customer/${customerId}`;

    return this.apiResponseHandler.get(apiCompanies).then((data) => handleResponseArray(data));
  };

  createCompany = async (companySubmission: RegionSubmission): Promise<number> => {
    const apiCompanies = `${CompanyAPIs.BASE_URL}`;
    return this.apiResponseHandler.post(apiCompanies, JSON.stringify(companySubmission.region), false);
  };

  createRegionMapping = async (regionMappingSubmission: RegionMappingSubmission): Promise<RegionMapping> => {
    const apiCompanies = `${CompanyAPIs.BASE_URL}parent/${regionMappingSubmission.regionMapping.parentId}/child/${regionMappingSubmission.regionMapping.subjectId}`;
    return this.apiResponseHandler.post(apiCompanies);
  };

  deleteCompany = async (companyId: number): Promise<null> => {
    const apiCompanies = `${CompanyAPIs.BASE_URL}${companyId}`;
    return this.apiResponseHandler.delete(apiCompanies, false);
  };
}
